import { http } from '@/utils/http';
import { logger } from '@/utils/logger';
import { AxiosError } from 'axios';
import { getOcelotConfig } from 'lib/configs/ocelot';
import { getAipAuthUrl } from './getAipAuthUrl';
import { getAipBffClient } from './getAipBffClient';

export const getClientCredentialsToken = async (): Promise<string | null> => {
  const tokenUrl = new URL(`/oauth2/token`, getAipAuthUrl());
  const { clientId, clientSecret } = getAipBffClient();
  const {
    bffOAuth: { scope, audience },
  } = getOcelotConfig('features.payments.v2');

  if (!scope || !audience) {
    console.error('Scope or audience not defined in Ocelot config for AIP Payments');
    return null;
  }

  const formValues = new URLSearchParams({
    grant_type: 'client_credentials',
    client_id: clientId,
    client_secret: clientSecret,
    scope,
    audience,
  });

  const response = await http
    .post(tokenUrl.href, formValues, {
      skipInterceptors: { response: { rejected: true } },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
    .catch((error: AxiosError) => {
      logger.error(
        `getClientCredentialsToken: token request failed with status ${error.response?.status ?? error.code}`,
        error.response?.data ?? error.message,
      );
      return null;
    });

  const data = response?.data;

  if (!data?.access_token) {
    logger.error('No client credential token found for AIP Auth:', data);
    return null;
  }

  return data.access_token;
};
